<template>
  <div class="wrapper">
  <AppLogo variant="prelogin"/>
  <div class="mb-25">
  <ForgotPassword/>
  </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AppLogo from "../../components/Widgets/AppLogo.vue";
import ForgotPassword from "../../components/Authentication/ForgotPassword/ForgotPassword.vue";

export default defineComponent({
  name: "ForgotPasswordPage",
  components: {
    AppLogo,
    ForgotPassword,
  },
});
</script>